<template>
  <div v-loading="pageLoading">
    <div>
      <!-- 搜索 -->
      <el-form :inline="true"
               :model="formInline"
               class="demo-form-inline">
        <el-form-item label="角色名稱"
                      :label-width="formLabelWidth">
          <el-input style="width: 223px;"
                    v-model="formInline.names"
                    placeholder="請輸入角色"></el-input>
        </el-form-item>
        <el-form-item label="包含權限"
                      :label-width="formLabelWidth">
          <el-input style="width: 223px;"
                    v-model="formInline.manMenuNames"
                    placeholder="請輸入權限"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="btn"
                     @click="loadMsg">搜尋</el-button>
          <el-button type="primary"
                     @click="add">新增</el-button>
        </el-form-item>
      </el-form>

      <!-- 彈窗 -->
      <el-dialog :title="title"
                 :visible.sync="dialogFormVisible"
                 width="500px">
        <el-form :model="form">
          <el-form-item label="角色名稱"
                        :label-width="formLabelWidth">
            <el-input v-model="form.name"
                      autocomplete="off"
                      :placeholder="dialogDataLoading ? '加載中' : '角色名稱'"
                      :disabled="dialogDataLoading"
                      style="width: 80%;"></el-input>
          </el-form-item>
          <el-form-item label="角色權限"
                        :label-width="formLabelWidth">
            <el-checkbox-group v-model="form.manMenuIds" :disabled="dialogDataLoading">
              <el-checkbox v-for="item in manMenuNames"
                          :key="item.id"
                          :label="item.id"
                          name="type"
                          border>{{item.menuName}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary"
                     @click="addRole" :loading="dialogLoading">確 定</el-button>
        </div>
      </el-dialog>

      <!-- 表格 -->
      <template>
        <el-table ref="singleTable"
                  :data="tableData"
                  style="width: 100%"
                  empty-text="暫無記錄"
                  border
                  @sort-change="sort">
          <el-table-column type="index"
                           label="序號"
                           width="80"></el-table-column>
          <el-table-column property="name"
                           label="角色名稱"
                           width="150"></el-table-column>
          <el-table-column sortable="custom"
                           property="creationTime"
                           label="創建時間"
                           width="180"></el-table-column>
          <el-table-column property="manMenuName"
                           label="權限"></el-table-column>
          <el-table-column label="操作"
                           width="250">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="warning"
                         @click="edit(scope.row.id)">編輯</el-button>
              <el-button size="mini"
                         type="danger"
                         @click="open(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <el-pagination :hide-on-single-page="true"
                     :total="total"
                     layout="prev, pager, next,total"
                     @current-change="pageChange"></el-pagination>
    </div>
  </div>
</template>

<script>
var that;
export default {
  data () {
    return {
      pageLoading: false,
      dialogDataLoading: false,
      dialogLoading: false,

      formInline: {
        names: '',
        manMenuNames: '',
        pageSize: 10,
        pageNum: 1,
        sortAsc: '',
        sortDesc: 'creationTime'
      },
      dialogFormVisible: false,
      // manMenuNames: ['课程管理', '活动管理', '意见管理', '分公司管理', '员工职位管理', '员工层级管理', '后台管理', '部门管理', '员工管理', '资讯管理', '地区管理', 'APP管理'],
      manMenuNames: ['課程管理', '活動管理', '意見管理', '分公司管理', '員工職位管理', '員工層級管理', '后台管理', '部門管理', '員工管理', '資訊管理', '地區管理', 'APP管理'],
      form: {
        name: '',
        manMenuIds: []
      },
      formLabelWidth: '80px',
      title: '',
      tableData: [],
      total: 0,
      roleId: ''
    };
  },
  mounted () {
    $('#pageHead').text('後台許可權分配');
    // 加载数据
    this.loadMsg();
    // 获取级联
    this.$store.dispatch('commonData/getEchoManMenuList').then(() => {
      this.manMenuNames = this.$store.state.commonData.echoManMenuList
    })
  },
  methods: {
    sort (msg) {
      // 排序
      var prop = msg.prop,
        order = msg.order,
        formInline = this.formInline;
      if (order == 'ascending') {
        formInline.sortDesc = prop;
        formInline.sortAsc = '';
      } else {
        formInline.sortDesc = '';
        formInline.sortAsc = prop;
      }
      that.loadMsg();
    },
    loadMsg () {
      this.pageLoading = true
      var msg = this.utils.filtration(that.formInline);
      this.axios({
        url: '/manage/getManRoleList',
        params: msg
      }).then(res => {
        if (res) {
          that.total = res.total;
          that.tableData = res.result;
        }
        this.pageLoading = false
      }).catch(() => {
        this.pageLoading = false
      })
    },
    add () {
      this.title = '新增';
      this.form.name = '';
      this.form.manMenuIds = [];
      this.dialogFormVisible = true;
    },
    edit (id) {
      this.dialogDataLoading = true
      this.title = '修改';
      this.axios({
        url: '/manage/getManRole',
        params: {
          id: id
        }
      }).then((res) => {
        if (res) {
          var msg = res.result[0];
          that.form.name = msg.name;
          var arr = msg.manMenuId.split(",");
          for (var i = 0; i < arr.length; i++) {
            arr[i] = parseInt(arr[i])
          }
          that.form.manMenuIds = arr;
          that.roleId = msg.id;
          this.dialogDataLoading = false
        }
      })
      this.dialogFormVisible = true;
    },
    addRole () {
      var msg = this.form;
      if (msg.name == '') {
        this.$message({
          type: 'warning',
          message: '請填寫角色名稱'
        });
        return;
      }
      if (msg.manMenuIds.length == 0) {
        this.$message({
          type: 'warning',
          message: '請選擇角色權限'
        });
        return;
      }
      var param = msg
      param.manMenuIds = param.manMenuIds.join(',')
      this.dialogLoading = true
      if (this.title === '新增') {
        this.axios({
          url: '/manage/addManRole',
          params: param,
          method: 'POST',
        }).then(res => {
          if (res) {
            that.$message({
              type: 'success',
              message: '新增成功!'
            });
            // 更新vuex中rolelist
            this.$store.dispatch('commonData/updateRoleList')
          }
          that.loadMsg();
          that.dialogFormVisible = false;
          this.dialogLoading = false
        }).catch(() => {
          this.dialogLoading = false
        })

      } else {
        this.axios({
          url: '/manage/updateManRole',
          params: {
            manMenuIds: param.manMenuIds,
            id: that.roleId,
            name: msg.name
          },
          method: 'post',
        }).then(res => {
          if (res) {
            that.$message({
              type: 'success',
              message: '修改成功!'
            });
            // 更新vuex中rolelist
            this.$store.dispatch('commonData/updateRoleList')
          }
          that.loadMsg();
          that.dialogFormVisible = false;
          this.dialogLoading = false
        }).catch(() => {
          this.dialogLoading = false
        })
      }
    },
    open (id) {
      this.$confirm('確認刪除該條角色信息？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '確定',
        type: 'warning'
      })
        .then(() => {
          this.pageLoading = true
          this.axios({ url: "/manage/delManRole", params: { id }, method: 'post' }).then((res) => {
            if (res) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.loadMsg()
              // 更新vuex中rolelist
              this.$store.dispatch('commonData/updateRoleList')
            }
            this.pageLoading = false
          }).catch(() => {
            this.pageLoading = false
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    pageChange (val) {
      that.formInline.pageNum = val;
      that.loadMsg()
    }
  },
  created () {
    that = this;
  }
};
</script>

<style scoped>
.btn {
  margin-left: 20px;
}
.dialog-footer {
  display: flex;
  justify-content: space-around;
}
.el-form-item .el-form-item__content .el-checkbox-group .el-checkbox {
  margin-left: 0px;
}
</style>
